// extracted by mini-css-extract-plugin
export var banner = "_ri-0";
export var settingRow = "_ri-2";
export var titleIcon = "_ri-1";